<template>
    <div>
        <div v-if="customer && customer.getOrganisation()"
             class="no-wrap">
            <i class="fa-regular fa-fw fa-building"></i> {{ customer.getOrganisation() }}
        </div>
        <div v-if="customer && customer.getFullName()"
             class="no-wrap">
            <i class="fa-solid fa-fw fa-user"></i> <ContactName :contact="customer.getContactContainingName()" />
        </div>
        <div v-if="customer && customer.getEmail()"
             class="no-wrap">
            <i class="fa-regular fa-fw fa-envelope"></i> {{ customer.getEmail() }}
        </div>
        <div v-if="customer && customer.getContact().tel"
             class="no-wrap">
            <i class="fa-regular fa-fw fa-phone"></i> {{ customer.getTel() }}
        </div>
        <div v-if="customer && customer.getAddress().postcode"
             class="no-wrap">
            <i class="fa-regular fa-fw fa-location-dot"></i> {{ customer.getAddress().postcode }}
        </div>
    </div>
</template>

<script>
import ContactName from '@/epos/vue/components/Customers/ContactName';

export default {
    name: 'CustomerInfo',

    components: {
        ContactName,
    },

    props: {
        customer: {
            type: Object,
            required: true,
        },
    },
};
</script>
